import { render, staticRenderFns } from "./Beneficios.vue?vue&type=template&id=4f833ab6"
import script from "./Beneficios.vue?vue&type=script&lang=js"
export * from "./Beneficios.vue?vue&type=script&lang=js"
import style0 from "./Beneficios.vue?vue&type=style&index=0&id=4f833ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports